/*
 * inselvolt Kompatibilitätsberater — Preisherkunft (reine Logik).
 *
 * Herausgelöst aus app/berater-ui.js (E6, 2026-08-25): die Zustandsmaschine
 * der Preisherkunft (datei → läuft → live/rückfall) und die Texte der
 * Herkunftszeile — testbar ohne DOM. Der fetch bleibt in app/preisquelle.js,
 * das Zeichnen in der UI.
 *
 * Invariante (CLAUDE.md): Fällt der Live-Abruf aus, sagt die UI das sichtbar
 * samt Datum — ein stiller Rückfall auf alte Preise ist ausgeschlossen.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.IVBeraterPreisstand = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  /* Die Meldung, mit der preisquelle.js den planmäßigen Betrieb ohne
   * hinterlegten Live-Zugang kennzeichnet — kein Störfall. */
  var OHNE_ZUGANG = 'kein Live-Zugang hinterlegt';

  /* Startzustand: Bis der Live-Abruf antwortet, gilt die gespeicherte Datei —
   * die Seite ist sofort benutzbar. */
  function start(preise) {
    return {
      quelle: 'datei',
      stand: preise && preise.quelle ? preise.quelle.abruf_datum : null,
      meldung: null,
      laeuft: true,
    };
  }

  /* Ergebnis von preisquelle.laden() → neuer Herkunftszustand. */
  function nachAbruf(ergebnis) {
    return {
      quelle: ergebnis.quelle,
      stand: ergebnis.stand,
      meldung: ergebnis.meldung,
      laeuft: false,
    };
  }

  /* Kein Preisquellen-Modul geladen: Der Dateistand bleibt, nichts läuft mehr. */
  function ohneQuelle(herkunft) {
    return {
      quelle: herkunft.quelle,
      stand: herkunft.stand,
      meldung: herkunft.meldung,
      laeuft: false,
    };
  }

  /*
   * Herkunft → Anzeige. Zwei verschiedene Sachverhalte, zwei verschiedene
   * Töne: Ohne eingerichteten Live-Zugang arbeitet der Berater planmäßig mit
   * dem täglichen Abgleich — kein Störfall. Ein versuchter und gescheiterter
   * Abruf dagegen heißt: Die Preise könnten überholt sein — das muss
   * auffallen (art 'rueckfall', eigene CSS-Klasse).
   */
  function anzeige(herkunft) {
    if (herkunft.laeuft) {
      return { art: 'laedt', text: 'Preise und Verfügbarkeit werden aus dem Shop geladen …' };
    }
    if (herkunft.quelle === 'live') {
      return { art: 'live', text: 'Preise und Verfügbarkeit soeben live aus dem inselvolt-Shop abgerufen.' };
    }
    if (herkunft.meldung === OHNE_ZUGANG) {
      return {
        art: 'abgleich',
        text: 'Preise und Verfügbarkeit aus dem täglichen Shop-Abgleich. Maßgeblich ist der '
          + 'Preis im Shop zum Bestellzeitpunkt.',
      };
    }
    return {
      art: 'rueckfall',
      text: 'Der Live-Abruf im Shop ist gerade nicht erreichbar. Sie sehen die Preise aus dem '
        + 'letzten Abgleich. Maßgeblich ist der Preis im Shop zum Bestellzeitpunkt.',
    };
  }

  return {
    start: start,
    nachAbruf: nachAbruf,
    ohneQuelle: ohneQuelle,
    anzeige: anzeige,
  };
});
